import { AbstractRepository } from '@/repositories/abstract-repository';
import { Task } from '@/tasks/models/task-models';

export interface GroupTaskCreateDto {
    task_activity: number;
    description: string;
    due_date_time: string;
    timezone: string;
    assigned_to?: number;
    assign_to_position?: number;
    notify_staff_email: boolean;
    notify_staff_text: boolean;
    show_on_calendar: boolean;
    excluded_families: Array<number> | null;
    included_families: Array<number> | null;
    org_id?: number;
}

export class GroupTasksRepository extends AbstractRepository<Task> {
    readonly endpoint = 'groups';

    public async createGroupTask(filterId: number, taskData: GroupTaskCreateDto): Promise<Task> {
        return await this.client.post(`${this.endpoint}/${filterId}/histories/tasks`, taskData);
    }
}
